var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "q-breadcrumb__item",
      style: this.$qt("direction") === "ltr" ? "float: left" : "float: right",
    },
    [
      _c(
        "span",
        {
          ref: "link",
          class: ["q-breadcrumb__inner", _vm.to ? "is-link" : ""],
          attrs: { role: "link" },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("i", {
        staticClass: "q-breadcrumb__separator",
        class:
          this.$qt("direction") === "ltr"
            ? "q-icon-arrow-right"
            : "q-icon-arrow-left",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }